import {
  PlanrScheduleStatus,
  PlanrScheduleType,
  WorkflowType,
  ProductionCostStatus,
  ProductionCostOrigin
} from '../store/types';

export const productionCostStatuses = [
  {
    name: 'In Production',
    key: ProductionCostStatus.InProduction
  },
  {
    name: 'Draft',
    key: ProductionCostStatus.Draft
  },
  {
    name: 'Planned',
    key: ProductionCostStatus.Planned
  }
];

export const productionCostOrigins = [
  {
    name: 'Automated',
    key: ProductionCostOrigin.Automated
  },
  {
    name: 'Manual',
    key: ProductionCostOrigin.Manual
  }
];

export const productionCostWorkflowTypes = [
  {
    name: 'Standard',
    key: WorkflowType.Standard
  },
  {
    name: 'Concept change',
    key: WorkflowType.ConceptChange
  }
];

export const productionCostLineStatuses = [
  {
    name: 'Published',
    key: PlanrScheduleStatus.Published
  },
  {
    name: 'Draft',
    key: PlanrScheduleStatus.Draft
  },
  {
    name: 'Archived',
    key: PlanrScheduleStatus.Archived
  },
  {
    name: 'Planned',
    key: PlanrScheduleStatus.Planned
  },
  {
    name: 'Final',
    key: PlanrScheduleStatus.Final
  }
];

export const planrScheduleTypes = [
  {
    name: 'Regular',
    key: PlanrScheduleType.Regular
  },
  {
    name: 'Holiday',
    key: PlanrScheduleType.Holiday
  }
];
